/**
 * Eval max length
 * @param value
 * @param maxLength
 * @returns
 */
export const maxLength = (value: string | undefined, maxLength: number) => {
    return !value ? true : value.trim().length <= maxLength ? true : false;
};

/**
 * Eval min length
 * @param value
 * @param minLength
 * @returns
 */
export const minLength = (value: string | undefined, minLength: number) => {
    return !value ? false : value.trim().length >= minLength ? true : false;
};

/**
 * Eval exact length
 * @param value
 * @param length
 * @returns
 */
export const exactLength = (value: string | undefined, length: number) => {
    return value?.trim().length === length;
};
